module.exports = __webpack_public_path__ + "static/media/book-solid.260b276f.svg";